import React from "react"
import Img from "gatsby-image"
import { ImgItem } from "./image-item"

const AboutShowStructure = ({ image }) => {
  return (
    <ImgItem>
      <div className="textWrapper">
        <h1>Show Structure</h1>

  <p1>
  Set the show structure. You can have as many acts or intervals as you
  like, in any order, with any names. Simply tap what you need and set
  your interval durations. Both acts and intervals can include markers -
  these allow you to timestamp parts of your act, for example a scene.
</p1>
      </div>

      <Img fluid={image.childImageSharp.fluid} alt="Image" className="image" />
    </ImgItem>
  )
}

export default AboutShowStructure